<template>
  <vs-card>
    <h4 class="mb-4">Course</h4>
    <div class="cstm_vuexy_table table-responsive">
      <table class="w-full">
        <thead>
          <tr>
            <th>Course Name</th>
            <th>Subject</th>
            <th>Course Class Type</th>
            <th>Session Frequency</th>
            <th>Students</th>
            <th style="width: 50px"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(eachData, index) in courseLists" :key="index">
            <td>
              {{ eachData.name }}
            </td>
            <td>
              {{
                eachData.has_all_subject
                  ? "General"
                  : eachData.subjects.length > 0
                  ? getSubjects(eachData.subjects)
                  : "Not Selected"
              }}
            </td>
            <td>
              {{ getType(eachData.course_class_type) }}
            </td>
            <td>
              {{ eachData.no_of_sessions }}
            </td>
            <td>
              <div class="flex items-center course_students_td">
                <span
                  class="cstm-img-holder"
                  v-for="(eachStud, index1) in eachData.students"
                  :key="index1"
                >
                  <vs-tooltip :text="eachStud.first_name+' '+eachStud.last_name" v-if="index1<3">
                    <img
                    v-if="eachStud.picture"
                      :src="eachStud.picture"
                      alt="user-img"
                      width="20"
                      height="20"
                      class="rounded-full shadow-md cursor-pointer block"
                    />
                    <img
                    v-else
                      src="@/assets/images/pages/user-circle-solid.svg"
                      alt="user-img"
                      width="20"
                      height="20"
                      class="rounded-full shadow-md cursor-pointer block"
                    />
                  </vs-tooltip>
                </span>
                <span class="text-muted pl-2 cursor-pointer" @click="studentModal(eachData.students)">
                  {{
                    eachData.students.length > 3
                      ? "+"
                      : ""
                  }}
                  {{
                    eachData.students.length > 3
                      ? eachData.students.length-3
                      : ""
                  }}
                </span>
              </div>
            </td>
          </tr>
          <tr v-if="courseLists.length==0" class="text-center">
            <td colspan="5">No Courses Found</td>
          </tr>
        </tbody>
      </table>
      <pagination
        style="float: right"
        :meta="meta"
        @page-change="handlePageChange"
      />
    </div>
    <div v-if="studentModalPopup">
      <vs-popup class="holamundo" title="Students" :active.sync="studentModalPopup">
        <div class="cstm_vuexy_table table-responsive">
          <table class="w-full">

            <tbody>
              <tr v-for="(eachData, index) in students" :key="index">
                <td>
                  <img
                    v-if="eachData.picture"
                      :src="eachData.picture"
                      alt="user-img"
                      width="20"
                      height="20"
                      class="rounded-full shadow-md cursor-pointer block"
                    />
                    <img
                    v-else
                      src="@/assets/images/pages/user-circle-solid.svg"
                      alt="user-img"
                      width="20"
                      height="20"
                      class="rounded-full shadow-md cursor-pointer block"
                    />
                </td>
                <td>
                  {{ eachData.first_name }} {{ eachData.last_name }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </vs-popup>
    </div>
  </vs-card>
</template>

<script>
import Pagination from '@/components/common/pagination'
import { newcourseListing } from '@/api/course-builderapi'
export default {
  components: {
    Pagination
  },
  data () {
    return {
      studentModalPopup:false,
      course_class_type_list: [
        {
          value: 'self_based',
          name: 'Self Paced Course'
        },
        {
          value: 'online_one_2_one',
          name: 'Online Individual Course'
        },
        {
          value: 'online_one_2_many',
          name: 'Online Group Course'
        },
        {
          value: 'offline_one_2_one',
          name: 'In Person Individual Course'
        },
        {
          value: 'offline_one_2_many',
          name: 'In Person Group Course'
        }
      ],
      courseLists: [],
      meta: {
        current_page: 1,
        has_next: true,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      allsubjectsArray: [],
      students:[]
    }
  },
  methods: {
    async studentModal (students) {
      this.studentModalPopup = true
      this.students = students
    },
    handlePageChange (page) {
      this.meta.current_page = page || 1

      setTimeout(() => {
        this.fetchCourseList()
      }, 0)
    },
    getType (type) {
      const class_type = this.course_class_type_list.filter((ele) => {
        return ele.value.includes(type)
      })
      if (class_type.length) return class_type[0].name
      return ''
    },
    getSubjects (subjects) {
      const subjectsArray = []
      subjects.forEach((e) => {
        subjectsArray.push(e.subject_name)
      })
      return subjectsArray.join(', ')
    },
    async fetchCourseList () {
      try {
        this.$vs.loading({
          text: 'Please Wait  ...'
        })
        const payload = {}
        const customer_id = this.$store.getters.customerId
        payload.limit = 10
        payload.user_id = this.$route.params.teacher_id ? this.$route.params.teacher_id : JSON.parse(localStorage.getItem('userInfo')).id
        const responeList = await newcourseListing(
          customer_id,
          payload,
          this.meta.current_page,
          {},
          'course_table'
        )

        this.courseLists = responeList.data.data.course
        this.meta = responeList.data.data.meta
      } catch (error) {
        //
        this.$vs.loading.close()
        console.log(error)
      } finally {
        this.$vs.loading.close()
      }
    }
  }
}
</script>
